<template>
  <el-dialog :visible.sync="show" title="选择补贴政策" width="600px">
    <div class="list" v-loading="isLoading">
      <div class="item" v-for="item in list" :key="item.id">
        <el-row :gutter="12">
          <el-col :span="2">
            <el-radio class="radio-item" :label="item.id" v-model="checkItem" />
          </el-col>
          <el-col :span="22">
            <div class="content">
              <div class="line"><span class="label">订单编号：</span>{{ rebateInfo.thirdOrderSn }}</div>
              <div class="line"><span class="label">补贴政策ID：</span>{{ item.id }}</div>
              <div class="line"><span class="label">补贴维度：</span>{{ item.rebateType }}</div>
              <div class="line red"><span class="label">结算佣金系数：</span>{{ item.subsidyRate }}%</div>
              <!-- <div class="line"><span class="label">结算佣金比例：</span>{{ rebateInfo | filterPromotionRate }}</div> -->
              <div class="line"><span class="label">结算佣金比例：</span>{{ computJxyjbl(item.subsidyRate, item.originalPromotionRate) }}</div>
              <div class="line"><span class="label">口令链接：</span>
                <div v-if="item.klUrl">
                  <div v-for="(kl, klIndex) in item.klUrl.split(',')" :key="klIndex">{{ kl }}</div>
                </div>
              </div>
              <div class="line"><span class="label">品牌名称/店铺名称：</span>{{ 
                // item.roomId ? `${item.roomName}(id:${item.roomId})` : item.goodsName
                item.shopName ? item.shopName : item.goodsName
               }}</div>
              <div class="line"><span class="label">原始佣金比例：</span>{{ item.originalPromotionRate ? item.originalPromotionRate / 10 : 0 }}%</div>
            </div>
          </el-col>
      </el-row>
    </div>
    </div>
    <div slot="footer">
      <el-button size="mini" @click="$emit('close')">关闭</el-button>
      <el-button size="mini" :disabled="!checkItem" @click="submitHandler" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import NP from 'number-precision'
import { computedPromotionRate } from '@/page/component/routes/index/order-manage/order-list/fields'
import { queryBdRebateInfo, modifyRebateInfoId } from '@/service/apis/order'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }, 
    reportType: {
      type: String,
      default: ''
    },
    rebateInfo: {
      type: Object,
      default: () => {}
    }
  }, 
  filters: {
    filterPromotionRate (row) {
      return computedPromotionRate(row) || '--'
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler (val) {
        if (val) {
          this.getList()
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      list: [],
      checkItem: null
    }
  },
  methods: {
    computJxyjbl (subsidyRate, originalPromotionRate) {
      subsidyRate = subsidyRate ? NP.divide(subsidyRate, 100) : 0
      originalPromotionRate = originalPromotionRate ? NP.divide(originalPromotionRate, 1000) : 0
      // return (subsidyRate) * (originalPromotionRate)
      return NP.times(NP.times(subsidyRate, originalPromotionRate), 100).toFixed(2) + '%'
    },
    getList () {
      this.isLoading = true
      queryBdRebateInfo.call(this, {
        rebateInfoIdList: this.rebateInfo.rebateConfirmIds
      }).then(res => {
        this.list = [...(res || [])]
      }).finally(() => {
        this.isLoading = false
      })
    },
    submitHandler () {
      // this.checkItem
      const paramsUrl = `?reportId=${this.rebateInfo.id}&rebateInfoId=${this.checkItem}`
      modifyRebateInfoId.call(this, paramsUrl).then(res => {
        console.log(res)
        if (res) {
          this.$message.success('修改成功')
          this.$emit('on-success')
        }
      })
    }
  }
}
</script>

<style scoped>
.list {
  max-height: 480px;
  overflow: auto;
}
.list .item {
  line-height: 18px;
  padding: 12px 0;
  border-bottom: solid 1px #ebebeb;
}
.list .item:last-child {
  border-bottom: none;
}
.list .content .line {
  padding: 4px 0;
  line-height: 20px;
  display: flex;
  align-items: top;
}
.list .content .line span {
  color: #999;
}
.item .radio-item {
  margin: 8px 0;
}
::v-deep .el-radio__label {
  display: none;
}
::v-deep .el-radio__inner {
  width: 24px;
  height: 24px;
  border: solid 1px #999;
}
</style>